module.exports = __webpack_public_path__ + "media/video.57f463f6.mp4";